import { FieldValues, useFormContext } from 'react-hook-form'
import { IFormField } from 'types'
import { ControlledField } from './ControlledField'
import { ReadonlyField } from './ReadonlyField'

interface IControlledFieldsProps<T extends FieldValues> {
  fields: IFormField<T>[]
  readonly?: boolean
  isLoading?: boolean
}

export const ControlledFields = <T extends FieldValues>({
  fields,
  readonly,
  isLoading
}: IControlledFieldsProps<T>) => {
  const methods = useFormContext<T>()

  return fields.map(field => {
    const ignoreField =
      typeof field.ignoreField === 'function'
        ? field.ignoreField(methods, field)
        : field.ignoreField

    if (ignoreField) return null

    const key = String(field.name)

    if (readonly) {
      return <ReadonlyField key={key} field={field} isLoading={isLoading} />
    }

    return <ControlledField key={key} field={field} isLoading={isLoading} />
  })
}
